"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { CustomLink } from "@repo/design-system/components/ui/custom-link";
import { Suspense, useState } from "react";
import { HamburgerButton } from "~/components/ui/hamburger-button-eon";
import { LanguageSwitcher } from "~/components/ui/language-switcher-eon";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "~/components/ui/sheet-eon";
import { useLanguage } from "~/translations/loader/use-language";
import ChevronRight from "../icons/chevron-right-eon";
export default function HeaderMain() {
  const $ = _c(53);
  const t = useLanguage();
  const [open, setOpen] = useState(false);
  let t0;
  if ($[0] !== t.header_navItem1 || $[1] !== t.header_navLink1) {
    t0 = {
      href: t.header_navLink1,
      label: t.header_navItem1
    };
    $[0] = t.header_navItem1;
    $[1] = t.header_navLink1;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== t.header_navItem2 || $[4] !== t.header_navLink2) {
    t1 = {
      href: t.header_navLink2,
      label: t.header_navItem2
    };
    $[3] = t.header_navItem2;
    $[4] = t.header_navLink2;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t.header_navItem3 || $[7] !== t.header_navLink3) {
    t2 = {
      href: t.header_navLink3,
      label: t.header_navItem3
    };
    $[6] = t.header_navItem3;
    $[7] = t.header_navLink3;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t.header_navItem4 || $[10] !== t.header_navLink4) {
    t3 = {
      href: t.header_navLink4,
      label: t.header_navItem4
    };
    $[9] = t.header_navItem4;
    $[10] = t.header_navLink4;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t.header_navItem5 || $[13] !== t.header_navLink5) {
    t4 = {
      href: t.header_navLink5,
      label: t.header_navItem5
    };
    $[12] = t.header_navItem5;
    $[13] = t.header_navLink5;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t.header_navItem6 || $[16] !== t.header_navLink6) {
    t5 = {
      href: t.header_navLink6,
      label: t.header_navItem6
    };
    $[15] = t.header_navItem6;
    $[16] = t.header_navLink6;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t0 || $[19] !== t1 || $[20] !== t2 || $[21] !== t3 || $[22] !== t4 || $[23] !== t5) {
    t6 = [t0, t1, t2, t3, t4, t5];
    $[18] = t0;
    $[19] = t1;
    $[20] = t2;
    $[21] = t3;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  const navItems = t6;
  let t7;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <CustomImage alt="E.ON Logo" height={28} src="images/logo/logo_color.svg" width={96} />;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  let t8;
  if ($[26] !== t.header_home) {
    t8 = <CustomLink aria-label={t.header_home} className="flex items-center p-4 lg:hidden" href="/" passParams={true} prefetch={false} title={t.header_home}>{t7}</CustomLink>;
    $[26] = t.header_home;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <CustomImage alt="E.ON Logo" height={28} src="images/logo/logo_color.svg" width={96} />;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== t.header_home) {
    t10 = <li><CustomLink aria-label={t.header_home} className="flex items-center p-4 pl-0" href="/" passParams={true} prefetch={false} title={t.header_home}>{t9}</CustomLink></li>;
    $[29] = t.header_home;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== navItems) {
    t11 = navItems.map(_temp);
    $[31] = navItems;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== t10 || $[34] !== t11) {
    t12 = <ul className="hidden h-full items-center text-lg leading-4 lg:flex">{t10}{t11}</ul>;
    $[33] = t10;
    $[34] = t11;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  let t13;
  if ($[36] !== t12 || $[37] !== t8) {
    t13 = <nav><div className="flex h-full w-full justify-between lg:justify-between">{t8}{t12}</div></nav>;
    $[36] = t12;
    $[37] = t8;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  let t14;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Suspense><LanguageSwitcher /></Suspense>;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  let t15;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <span className="sr-only">Menu</span>;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] !== open) {
    t16 = <SheetTrigger asChild={true} className="my-auto min-h-[32px] min-w-[32px] cursor-pointer lg:hidden"><button className="flex items-center gap-2" type="button">{t15}<HamburgerButton isOpen={open} /></button></SheetTrigger>;
    $[41] = open;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  let t17;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <SheetHeader className="flex flex-row items-center justify-around"><SheetTitle className="sr-only">Menu</SheetTitle></SheetHeader>;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  let t18;
  if ($[44] !== navItems) {
    t18 = <SheetContent className="top-16 h-[calc(100vh-4rem)] w-[296px] border-white bg-card md:w-[305px]" showCloseButton={false} side="right">{t17}<ul className="text-lg">{navItems.map(_temp2)}</ul></SheetContent>;
    $[44] = navItems;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[46] !== open || $[47] !== t16 || $[48] !== t18) {
    t19 = <div className="absolute top-0 right-6 flex h-full items-center justify-center gap-5 md:right-10 md:items-center lg:static">{t14}<Sheet modal={true} onOpenChange={setOpen} open={open}>{t16}{t18}</Sheet></div>;
    $[46] = open;
    $[47] = t16;
    $[48] = t18;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  let t20;
  if ($[50] !== t13 || $[51] !== t19) {
    t20 = <header className="sticky top-0 z-50 h-16 w-full bg-white text-foreground print:hidden"><div className="relative w-full border-gray-200 border-b-4"><div className="mx-auto flex h-16 max-w-screen-xl justify-between px-4 text-center">{t13}{t19}</div></div></header>;
    $[50] = t13;
    $[51] = t19;
    $[52] = t20;
  } else {
    t20 = $[52];
  }
  return t20;
}
function _temp2(t0) {
  const {
    href,
    label
  } = t0;
  return <li className="border-gray-300 border-b" key={href}><CustomLink blank={true} className="flex justify-between px-8 py-3 leading-6" href={href}><span data-source="lc">{label}</span><ChevronRight className="size-5 text-foreground" /></CustomLink></li>;
}
function _temp(item) {
  return <li className="hover:underline hover:underline-offset-8" key={item.href}><CustomLink blank={true} className="flex h-full px-3 xl:px-4" data-source="lc" href={item.href}><span>{item.label}</span></CustomLink></li>;
}